import { render, staticRenderFns } from "./NgSurvey.vue?vue&type=template&id=3a2fdee6"
import script from "./NgSurvey.vue?vue&type=script&lang=js"
export * from "./NgSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports